import { render, staticRenderFns } from "./SuggestComponentDialog.vue?vue&type=template&id=5f260490&scoped=true"
import script from "./SuggestComponentDialog.vue?vue&type=script&lang=js"
export * from "./SuggestComponentDialog.vue?vue&type=script&lang=js"
import style0 from "./SuggestComponentDialog.vue?vue&type=style&index=0&id=5f260490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f260490",
  null
  
)

export default component.exports